export default {
  developerEnabled: (state) => state.developerEnabled,
  active: (state) => state.active,
  expanded: (state) => state.expanded,
  debugApi: (state) => state.debugApi,
  showPermissions: (state) => state.showPermissions,
  showRequests: (state) => state.showRequests,
  showResponses: (state) => state.showResponses,
  logLevel: (state) => state.logLevel,

};
